import { render, staticRenderFns } from "./RiskGraphs.vue?vue&type=template&id=11739f99&scoped=true&"
import script from "./RiskGraphs.vue?vue&type=script&lang=ts&"
export * from "./RiskGraphs.vue?vue&type=script&lang=ts&"
import style0 from "./RiskGraphs.vue?vue&type=style&index=0&id=11739f99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11739f99",
  null
  
)

export default component.exports